/**
 * Converts a viewport height (vh) value to pixels.
 *
 * @param {number} vh - The vh value to convert.
 * @returns {number} The equivalent value in pixels.
 */
export function vhToPx(vh) {
  // Use visualViewport.height if available, otherwise fallback to window.innerHeight
  const viewportHeight =
    typeof window.visualViewport !== 'undefined'
      ? window.visualViewport.height
      : Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

  // Calculate the pixel value based on the formula: px = (vh / 100) * viewportHeight
  return (vh / 100) * viewportHeight
}
